import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import Layout from "@/_LayoutsRelated/layout/Layout";
import { useEffect, useMemo } from "react";
import stl from './TrackingFinanceReturnForm.module.css';
import FormLabel from "@/pages/tracking/trackingReturn/TrackingFinanceReturnForm/components/FormLabel";
import { CDN_LINK } from "@globalConfig";
import { useForm } from 'react-hook-form';
import erp_cities_with_areas from "@data/lookups_language_customized/erp_cities_with_areas.json";
import { useLang } from "@/common/Contexts/LanguageContext";
import { ucWords } from "@/utils/stringHelpers";
import toast from "react-hot-toast";
import { api__createReturnOrder, api__returnUploadDocument } from "@/apis/orderTracking/return-order";
import useBoolean from "@hooks/useBoolean";
import SharedPopUp from "@componentsShared/SharedPopUp/SharedPopUp";
import ReturnsTermsAndConditions from "@/pages/tracking/trackingReturn/TrackingFinanceReturnForm/components/ReturnsTermsAndConditions";
import DeskTopBlueMobileWhiteHeader from "@/components/sharedComponents/DeskTopBlueMobileWhiteHeader/DeskTopBlueMobileWhiteHeader";
import useHelpers from "@hooks/useHelpers";
import { useTrackingReturnWizard } from "@/pages/tracking/trackingReturn/TrackingReturnWizardContext";
import { RHFSelect } from "@/common/HOCs/rhf/select/RHFSelect";
import { Form } from "@/common/HOCs/rhf/form-provider/FormProvider";
import { RHFSelectTwo } from "@/common/HOCs/rhf/select/RHFSelectTwo";
import { z as zod } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { RHFUpload } from "@/common/HOCs/rhf/upload/RHFUpload";
import RHFTextarea from "@/common/HOCs/rhf/textarea/RHFTextarea";
import RHFCheckbox from "@/common/HOCs/rhf/checkbox/RHFCheckbox";
import erp_return_reason from "@data/lookups/erp_return_reason.json";
import { trackEvents } from "@/common/events/events";
import { useSession } from "@/_MiniApps/auth/AuthContext";
var validateFileType = function validateFileType(file, allowedTypes) {
  var _file$name$split$pop;
  var fileExtension = (_file$name$split$pop = file.name.split('.').pop()) === null || _file$name$split$pop === void 0 ? void 0 : _file$name$split$pop.toLowerCase();
  return allowedTypes.includes(".".concat(fileExtension));
};
var TrackingReturnForm = zod.object({
  return_reason: zod.string().min(1, {
    message: "return_form/return_reason"
  }),
  customer_city: zod.string().min(1, {
    message: 'return_form/customer_city'
  }),
  customer_photos: zod.array(zod.custom()).optional().refine(function (files) {
    if (!files || files.length === 0) return true;
    return files.every(function (file) {
      return validateFileType(file, ['.jpeg', '.jpg', '.png', '.pdf']);
    });
  }, {
    message: 'upload/file-invalid-type'
  }),
  odometer_photo: zod.array(zod.custom()).min(1, {
    message: 'return_form/odometer_photo'
  }).refine(function (files) {
    return files.every(function (file) {
      return validateFileType(file, ['.jpeg', '.jpg', '.png', '.pdf']);
    });
  }, {
    message: 'upload/file-invalid-type'
  }),
  customer_notes: zod.string().max(500, {
    message: 'return_form/customer_notes'
  }).optional(),
  send_whatsapp_notification: zod["boolean"]().optional()
});
var TrackingFinanceReturnForm = function TrackingFinanceReturnForm() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var lang = useLang();
  var returnReasons = erp_return_reason.map(function (reason) {
    return {
      key: reason.return_reason,
      value: lang === "ar" ? reason.return_reason_arabic : reason.return_reason
    };
  });
  var confirm = useBoolean(false);
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useTrackingReturnWiz = useTrackingReturnWizard(),
    orderData = _useTrackingReturnWiz.orderData,
    goToStep = _useTrackingReturnWiz.goToStep;
  var loader = useBoolean(false);
  var cities = erp_cities_with_areas[lang] || [];
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn,
    user = _useSession.user;
  var defaultValues = useMemo(function () {
    return {
      return_reason: '',
      customer_city: cities.filter(function (city) {
        return parseInt(city.id) == (orderData === null || orderData === void 0 ? void 0 : orderData.city_id);
      })[0].id.toString(),
      odometer_photo: [],
      customer_photos: [],
      customer_notes: '',
      send_whatsapp_notification: true
    };
  }, []);
  useEffect(function () {
    if (isLoggedIn) {
      trackEvents("return_request_form_start", {
        order_id: "".concat(orderData.order_id)
      });
    }
  }, [orderData.order_uuid]);
  var methods = useForm({
    mode: "all",
    resolver: zodResolver(TrackingReturnForm),
    defaultValues: defaultValues
  });
  var handleSubmit = methods.handleSubmit,
    _methods$formState = methods.formState,
    isValid = _methods$formState.isValid,
    errors = _methods$formState.errors,
    setError = methods.setError,
    clearErrors = methods.clearErrors;
  var onSubmit = handleSubmit(/*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(data) {
      var _orderData$order_id, odometer_photo, customer_photos, _orderData$order_uuid, flattenedOdometerPhotos, odometerResponse, _uploadError$message, _uploadError$message2, _uploadError$validati, _uploadError$validati2, errorMessage, _orderData$order_uuid2, flattenedCustomerPhotos, customerResponse, formData, res, _Object$values, _Object$values$, _errorMessage, _t, _t2;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            // Clear any previous validation errors
            clearErrors(["odometer_photo", "customer_photos"]);
            loader.setTrue();
            _context.p = 1;
            odometer_photo = [];
            customer_photos = [];
            _context.p = 2;
            flattenedOdometerPhotos = data.odometer_photo.flat();
            _context.n = 3;
            return api__returnUploadDocument(flattenedOdometerPhotos, orderData === null || orderData === void 0 ? void 0 : orderData.isFinance, orderData === null || orderData === void 0 ? void 0 : (_orderData$order_uuid = orderData.order_uuid) === null || _orderData$order_uuid === void 0 ? void 0 : _orderData$order_uuid.toString(), 1);
          case 3:
            odometerResponse = _context.v;
            odometer_photo = _toConsumableArray(Object.values(odometerResponse));
            _context.n = 6;
            break;
          case 4:
            _context.p = 4;
            _t = _context.v;
            if (!(_t.validation_errors || (_uploadError$message = _t.message) !== null && _uploadError$message !== void 0 && _uploadError$message.includes("Failed to upload files to aws") || (_uploadError$message2 = _t.message) !== null && _uploadError$message2 !== void 0 && _uploadError$message2.includes("Failed to get pre-signed URLs"))) {
              _context.n = 5;
              break;
            }
            errorMessage = ((_uploadError$validati = _t.validation_errors) === null || _uploadError$validati === void 0 ? void 0 : (_uploadError$validati2 = _uploadError$validati.documents) === null || _uploadError$validati2 === void 0 ? void 0 : _uploadError$validati2[0]) || tShort("upload/file-invalid-type", {
              ns: "validations"
            });
            setError("odometer_photo", {
              type: "manual",
              message: errorMessage
            });
            loader.setFalse();
            return _context.a(2);
          case 5:
            throw _t;
          case 6:
            if (!(data.customer_photos && data.customer_photos.length > 0)) {
              _context.n = 8;
              break;
            }
            flattenedCustomerPhotos = data.customer_photos.flat();
            _context.n = 7;
            return api__returnUploadDocument(flattenedCustomerPhotos, orderData === null || orderData === void 0 ? void 0 : orderData.isFinance, orderData === null || orderData === void 0 ? void 0 : (_orderData$order_uuid2 = orderData.order_uuid) === null || _orderData$order_uuid2 === void 0 ? void 0 : _orderData$order_uuid2.toString(), 2);
          case 7:
            customerResponse = _context.v;
            customer_photos = _toConsumableArray(Object.values(customerResponse));
          case 8:
            formData = {
              send_whatsapp_notification: data.send_whatsapp_notification ? 1 : 0,
              order_id: orderData === null || orderData === void 0 ? void 0 : (_orderData$order_id = orderData.order_id) === null || _orderData$order_id === void 0 ? void 0 : _orderData$order_id.toString(),
              order_type: orderData !== null && orderData !== void 0 && orderData.isFinance ? 2 : 1,
              customer_city: data.customer_city,
              return_reason: data.return_reason,
              customer_notes: data.customer_notes,
              odometer_photo: odometer_photo,
              customer_photos: customer_photos
            };
            _context.n = 9;
            return api__createReturnOrder(formData);
          case 9:
            res = _context.v;
            loader.setFalse();
            if ((res === null || res === void 0 ? void 0 : res.success) === false) {
              _errorMessage = res.errors ? (_Object$values = Object.values(res.errors)) === null || _Object$values === void 0 ? void 0 : (_Object$values$ = _Object$values[0]) === null || _Object$values$ === void 0 ? void 0 : _Object$values$[0] : t("error_something_went_wrong", {
                ns: "web_common"
              });
              toast.error(_errorMessage);
              goToStep("error");
            } else {
              if (isLoggedIn) {
                trackEvents("return_request_submit", {
                  order_id: "".concat(orderData.order_id),
                  return_reason: formData.return_reason,
                  original_delivery_city: "".concat(orderData.city_id),
                  customer_city: "".concat(formData.customer_city),
                  odometer_photo_upload: "true",
                  issue_photos_upload: "".concat(formData.customer_photos.length),
                  whatsapp_opt_in: "".concat(!!formData.send_whatsapp_notification)
                });
              }
              toast.success(t("request_submitted_successfully", {
                ns: "web_common"
              }));
              sessionStorage.removeItem("orderData-".concat(orderData === null || orderData === void 0 ? void 0 : orderData.order_uuid));
              goToStep("success");
            }
            _context.n = 11;
            break;
          case 10:
            _context.p = 10;
            _t2 = _context.v;
            console.error("Unexpected error:", _t2);
            toast.error(t("error_something_went_wrong", {
              ns: "web_common"
            }));
            goToStep("error");
          case 11:
            _context.p = 11;
            loader.setFalse();
            return _context.f(11);
          case 12:
            return _context.a(2);
        }
      }, _callee, null, [[2, 4], [1, 10, 11, 12]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
  return /*#__PURE__*/React.createElement(Layout, {
    hideOrangeHeadBtn: true,
    hideFooter: true,
    hideSideMenue: true,
    hideAppBanner: true,
    mobileNoLogo: true,
    hideHeaderOnmobile: true,
    custommobileHeader: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: stl.mobileHeaderBox
    }, /*#__PURE__*/React.createElement("div", {
      onClick: function onClick() {
        navigateTo("/tracking-landing");
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: CDN_LINK + "/assets/images/close.svg",
      alt: "",
      width: "16",
      height: "16"
    })), /*#__PURE__*/React.createElement("div", {
      className: stl.mobileHeaderTitle
    }, t("submit_return_request", {
      ns: "web_tracking_finance"
    })), /*#__PURE__*/React.createElement("div", {
      className: stl.emptyHeaderButton
    })))
  }, /*#__PURE__*/React.createElement(DeskTopBlueMobileWhiteHeader, {
    className2: stl.customBackground,
    title: t("submit_return_request", {
      ns: "web_tracking_finance"
    }),
    hasDeskTopBack: true,
    backButtonText: t("cancel", {
      ns: "web_tracking_finance"
    }),
    hideMobile: true,
    onClick: function onClick() {
      return navigateTo("/tracking-landing");
    }
  }), /*#__PURE__*/React.createElement("section", {
    className: stl.formWrapper
  }, /*#__PURE__*/React.createElement("h2", {
    className: stl.mainHeading
  }, t("validation_fill_required_details_submit_return", {
    ns: "web_tracking_finance"
  })), /*#__PURE__*/React.createElement(Form, {
    methods: methods,
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.form
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.formField
  }, /*#__PURE__*/React.createElement(FormLabel, {
    label: t("reason_return", {
      ns: "web_checkout_finance"
    })
  }), /*#__PURE__*/React.createElement(RHFSelect, {
    name: "return_reason",
    placeholder: t("select_reason", {
      ns: "web_checkout_finance"
    }),
    options: returnReasons.map(function (reason) {
      return {
        id: reason.key,
        label: lang === "ar" ? reason.value : reason.key,
        item: reason
      };
    })
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.formField
  }, /*#__PURE__*/React.createElement(FormLabel, {
    label: t("city_car_delivery", {
      ns: "web_checkout_finance"
    })
  }), /*#__PURE__*/React.createElement(RHFSelectTwo, {
    name: "customer_city",
    options: cities.map(function (city) {
      return {
        id: city.id,
        label: ucWords((lang === "ar" ? city.name_ar : city.name_en) || ""),
        item: city
      };
    }),
    searchable: cities.map(function (city) {
      return {
        id: city.id,
        label: ucWords((lang === "ar" ? city.name_en : city.name_ar) || ""),
        item: city
      };
    }),
    placeHolder: t("select_model", {
      ns: "web_common"
    }),
    className: stl.inputFieldSearch
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.formField
  }, /*#__PURE__*/React.createElement(FormLabel, {
    label: t("odometer_image", {
      ns: "web_checkout_finance"
    })
  }), /*#__PURE__*/React.createElement(RHFUpload, {
    name: "odometer_photo",
    placeholder: t("upload_current_odometer_image", {
      ns: "web_common"
    }),
    enablePreview: true,
    multiple: true,
    maxFiles: 1,
    accept: {
      "image/*": [".jpeg", ".jpg", ".png"],
      "application/pdf": [".pdf"]
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.formField
  }, /*#__PURE__*/React.createElement(FormLabel, {
    label: t("note_image", {
      ns: "web_checkout_finance"
    }),
    optional: true
  }), /*#__PURE__*/React.createElement(RHFUpload, {
    name: "customer_photos",
    multiple: true,
    placeholder: t("attach_photo_note", {
      ns: "web_common"
    }),
    maxFiles: 3,
    enablePreview: true,
    multiFilePlaceholder: t("upload_another_image", {
      ns: "web_common"
    }),
    accept: {
      "image/*": [".jpeg", ".jpg", ".png"],
      "application/pdf": [".pdf"]
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.formField
  }, /*#__PURE__*/React.createElement(FormLabel, {
    label: t("note_explanation", {
      ns: "web_checkout_finance"
    }),
    optional: true
  }), /*#__PURE__*/React.createElement(RHFTextarea, {
    name: "customer_notes",
    placeholder: t("write_here", {
      ns: "web_tracking_finance"
    }),
    resize: "none"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.formField
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.checkBoxLabel
  }, /*#__PURE__*/React.createElement("label", {
    className: [stl.whtsFlx].join(" ")
  }, /*#__PURE__*/React.createElement(RHFCheckbox, {
    name: "send_whatsapp_notification"
  }), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/wpImg.svg",
    alt: "whts",
    width: "24px",
    height: "24px"
  }), /*#__PURE__*/React.createElement("span", null, t("like_receive_updates_order_via", {
    ns: "web_checkout_finance"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: stl.formField
  }, /*#__PURE__*/React.createElement("span", {
    className: stl.financeConditions,
    onClick: confirm.setTrue
  }, t("terms_conditions_car_return", {
    ns: "web_checkout_finance"
  })))), /*#__PURE__*/React.createElement("div", {
    className: stl.submitBtnBox
  }, /*#__PURE__*/React.createElement("button", {
    className: stl.submitBtn,
    type: "submit",
    disabled: !isValid || loader.value || errors.odometer_photo || errors.customer_photos
  }, loader.value ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: stl.loader
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, t("submit_return_request", {
    ns: "web_checkout_finance"
  })))))), /*#__PURE__*/React.createElement(SharedPopUp, {
    oowh: true,
    show: confirm.value,
    onClose: confirm.setFalse
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.modalPaddingDesktop
  }, /*#__PURE__*/React.createElement(ReturnsTermsAndConditions, null))));
};
export default TrackingFinanceReturnForm;